/**
 * Diagram search: highlight nodes by keyword, center next/prev, clear.
 * Uses window.myDiagram, sessionStorage, jQuery, document.
 */

function buildSearchExamples(regex) {
  const examples = [
    { headline: regex },
    { country: regex }
  ];
  for (let i = 0; i <= 297; i++) {
    examples.push({ ['name_' + i]: regex }, { ['title_' + i]: regex });
  }
  return examples;
}

function searchDiagram() {
  if (!window.myDiagram) return;
  window.myDiagram.startTransaction('highlight search');
  window.myDiagram.clearHighlighteds();

  if (sessionStorage['search_keyword'] != '') {
    const regex = new RegExp(sessionStorage['search_keyword'], 'i');
    const examples = buildSearchExamples(regex);
    const search_results = window.myDiagram.findNodesByExample.apply(window.myDiagram, examples);

    sessionStorage['search_results_keys'] = '[]';
    sessionStorage['current_result'] = 0;
    search_results.each(function (item) {
      let keys = JSON.parse(sessionStorage['search_results_keys']);
      keys = $.merge(keys, [item.data.key]);
      sessionStorage['search_results_keys'] = JSON.stringify(keys);
    });

    window.myDiagram.highlightCollection(search_results);
    if (search_results.count > 0) {
      window.myDiagram.zoomToRect(search_results.first().actualBounds);
      window.myDiagram.centerRect(search_results.first().actualBounds);
      window.myDiagram.commandHandler.decreaseZoom(0.3);
    }

    const numEl = document.getElementById('search_results_number');
    const navEl = document.getElementById('search_results_navigation_buttons_container');
    if (search_results.count === 0) {
      window.myDiagram.clearHighlighteds();
      if (numEl) numEl.innerHTML = '';
      if (navEl) navEl.innerHTML = '';
      window.myDiagram.commandHandler.zoomToFit();
    } else if (search_results.count === 1) {
      if (numEl) numEl.innerHTML = '1 result';
      if (navEl) navEl.innerHTML = document.getElementById('search_results_navigation_buttons_only_one_result').innerHTML;
    } else {
      if (numEl) numEl.innerHTML = search_results.count.toString() + ' results';
      if (navEl) navEl.innerHTML = document.getElementById('search_results_navigation_buttons').innerHTML;
    }
  } else {
    window.myDiagram.clearHighlighteds();
    const numEl = document.getElementById('search_results_number');
    const navEl = document.getElementById('search_results_navigation_buttons_container');
    if (numEl) numEl.innerHTML = '';
    if (navEl) navEl.innerHTML = '';
    window.myDiagram.commandHandler.zoomToFit();
  }

  window.myDiagram.commitTransaction('highlight search');
}

function centerToNextResult() {
  if (!window.myDiagram) return;
  let current_result = parseInt(sessionStorage['current_result'], 10);
  const search_results_keys = JSON.parse(sessionStorage['search_results_keys']);

  if (current_result + 1 < search_results_keys.length) {
    sessionStorage['current_result'] = current_result + 1;
    const key = search_results_keys[current_result + 1];
    const part = window.myDiagram.findPartForKey(key);
    if (part) {
      window.myDiagram.zoomToRect(part.actualBounds);
      window.myDiagram.centerRect(part.actualBounds);
      window.myDiagram.commandHandler.decreaseZoom(0.3);
    }
  } else {
    sessionStorage['current_result'] = 0;
    const key = search_results_keys[0];
    const part = window.myDiagram.findPartForKey(key);
    if (part) {
      window.myDiagram.zoomToRect(part.actualBounds);
      window.myDiagram.centerRect(part.actualBounds);
      window.myDiagram.commandHandler.decreaseZoom(0.3);
    }
  }
}

function centerToPreviousResult() {
  if (!window.myDiagram) return;
  let current_result = parseInt(sessionStorage['current_result'], 10);
  const search_results_keys = JSON.parse(sessionStorage['search_results_keys']);

  if (current_result - 1 >= 0) {
    sessionStorage['current_result'] = current_result - 1;
    const key = search_results_keys[current_result - 1];
    const part = window.myDiagram.findPartForKey(key);
    if (part) {
      window.myDiagram.zoomToRect(part.actualBounds);
      window.myDiagram.centerRect(part.actualBounds);
      window.myDiagram.commandHandler.decreaseZoom(0.3);
    }
  } else {
    sessionStorage['current_result'] = search_results_keys.length - 1;
    const key = search_results_keys[search_results_keys.length - 1];
    const part = window.myDiagram.findPartForKey(key);
    if (part) {
      window.myDiagram.zoomToRect(part.actualBounds);
      window.myDiagram.centerRect(part.actualBounds);
      window.myDiagram.commandHandler.decreaseZoom(0.3);
    }
  }
}

function clearSearch() {
  if (!window.myDiagram) return;
  sessionStorage['current_result'] = 0;
  sessionStorage['search_results_keys'] = '[]';

  const numEl = document.getElementById('search_results_number');
  const navEl = document.getElementById('search_results_navigation_buttons_container');
  if (numEl) numEl.innerHTML = '';
  if (navEl) navEl.innerHTML = '';
  const searchBar = document.getElementById('search_bar');
  if (searchBar) searchBar.value = '';
  if (typeof $ !== 'undefined') $('#search_bar').val('');

  window.myDiagram.startTransaction('highlight search');
  window.myDiagram.clearHighlighteds();
  window.myDiagram.commitTransaction('highlight search');
  window.myDiagram.commandHandler.zoomToFit();
}

export { searchDiagram, centerToNextResult, centerToPreviousResult, clearSearch };
